/* eslint-disable max-statements */
import React from 'react';
import { getSellerBadge, getSellerSales } from '../helpers/seller-reputation';
import { IWithSellerReputationProps, IWithSellerReputationInjectedProps } from '../types';

export const withSellerReputation = (Component: React.FC<IWithSellerReputationInjectedProps>) => (
  props: IWithSellerReputationProps
) => {
  const { product, device } = props;
  const offer = product?.offer;
  const seller = offer?.seller;
  const loyalty = seller?.loyalty;
  const cnpj = seller?.id;

  if (!loyalty) {
    return <></>;
  }

  const cnpjAmericanasB2W = '00776574000660';
  const cnpjAmericanasLasaO2O = '33014556000196';
  const cnpjAmericanasLasaCD = '33014556138384';
  const cnpjAmericanasLasaDarkStore = '23559907000190';

  if (
    cnpj === cnpjAmericanasB2W ||
    cnpj === cnpjAmericanasLasaO2O ||
    cnpj === cnpjAmericanasLasaCD ||
    cnpj === cnpjAmericanasLasaDarkStore
  ) {
    const componentProps = {
      device,
      salesRange: getSellerSales('Loja Faixa 5'),
      badge: getSellerBadge('Loja Oficial'),
      hasBadgeCustomCare: true,
      hasBadgeFastDelivery: true,
      hasBadgeSalesVolume: true,
      seller: {
        image: 'https://images-americanas.b2w.io/marketplace/logo/grande/33014556000196.jpg',
        name: 'Americanas',
      },
    };

    return <Component {...componentProps} />;
  }

  const componentProps = {
    device,
    salesRange: getSellerSales(loyalty?.salesRange),
    badge: getSellerBadge(loyalty?.badge),
    hasBadgeCustomCare: loyalty?.badgeCustomerCare,
    hasBadgeFastDelivery: loyalty?.badgeFastDelivery,
    hasBadgeSalesVolume: loyalty?.badgeSalesVolume,
    seller: {
      image: seller?.image?.main,
      name: seller?.name,
      location: `${seller?.address?.city}, ${seller?.address?.state}`,
    },
  };

  return <Component {...componentProps} />;
};

export default withSellerReputation;
